import React from 'react';
import { RecentPurchases as B2BRecentPurchases, RecentOrders as B2CRecentPurchases, } from '@thd-olt-component-react/recent-order-details';
import { useNavigate } from '@thd-olt-component-react/router';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
export var RecentPurchases = function (_a) {
    var isB2B = _a.isB2B;
    var navigate = useNavigate();
    var onError = function (error) {
        if (error === 'authorizationError') {
            navigate('/auth/view/signin?redirect=/');
        }
    };
    return (React.createElement(React.Fragment, null, isB2B ? (React.createElement(ErrorBoundary, { name: "recent-purchases" },
        React.createElement(B2BRecentPurchases, { onError: onError }))) : (React.createElement(ErrorBoundary, { name: "recent-order-details" },
        React.createElement(B2CRecentPurchases, null)))));
};
